import React, { type ReactNode } from 'react'
import TruncatedText from '@components/common/TruncatedText/TruncatedText.component'

export function renderDashboardTruncatedText(
  value?: unknown,
  className?: string,
): ReactNode {
  return <TruncatedText text={String(value ?? '')} className={className} />
}
